import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledCard = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	padding: 1rem;

	background-color: #353535;
	border-radius: 10px;
	box-shadow: 2px 6px 13px -4px rgba(0, 0, 0, 0.57);
`;

function Card({ children }) {
	return <StyledCard>{children}</StyledCard>;
}

Card.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Card;
